<template>
  <hm-content title="">
    <div>
      <div style="margin-bottom: 20px;display:flex;justify-content:space-between;align-items:center;">
        <el-radio-group
          v-model="typeVal"
          @change="handoff"
          size="small"
        >
          <el-radio-button label="serve">服务预约</el-radio-button>
          <el-radio-button label="commodity">商品订单</el-radio-button>
          <el-radio-button label="pos">线下订单</el-radio-button>
          <el-radio-button label="serviceItem">服务项目</el-radio-button>
        </el-radio-group>
        <div>
          <el-button type="primary" size="small" @click="openGuideSettings">订单评价引导</el-button>
          <el-button type="primary" size="small" @click="openSettings">客评配置</el-button>
        </div>
      </div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="评价项目"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="helpText"
          label="项目别称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="helpText"
          label="分类"
        >
        <template slot-scope="scope">
          <p v-if="scope.row.code === 'orderScoreConfig'">商品订单评价</p>
          <p v-if="scope.row.code === 'serviceReservationScoreConfig'">服务预约评价</p>
          <p v-if="scope.row.code === 'posOrderScoreConfig'">线下订单评价</p>
          <p v-if="scope.row.code === 'serviceItemScoreConfig'">服务项目评价</p>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="value"
          label="状态"
        >
          <template slot-scope="scope">
            <div :class="scope.row.value === 'yes' ? 'success' : 'danger'">
              {{ scope.row.value === "yes" ? "开启" : "关闭" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="up(scope.row)"
                :class="scope.row.value === 'yes' ? 'danger' : 'success'"
              >
                {{ scope.row.value === "yes" ? "关闭" : "开启" }}</el-button
              >
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="78px"
      >
        <el-form-item label="评价项目" prop="name">
          <el-input
            clearable
            maxlength="50"
            disabled
            v-model.trim="ruleForm.name"
            placeholder="请输入评价项目"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目别称" prop="helpText">
          <el-input
            clearable
            maxlength="50"
            v-model.trim="ruleForm.helpText"
            placeholder="请输入项目别称"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否开启" prop="value">
          <el-switch
            v-model="ruleForm.value"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="yes"
            active-text="开启"
            inactive-text="关闭"
            inactive-value="no"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submit('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="客评配置"
      :visible.sync="settingsVisible"
      :close-on-click-modal="false"
      width="780px"
    >
      <el-form
        :model="settingsForm"
        label-width="100px"
        size="small"
        class="evaluation-config-form"
      >
        <el-divider content-position="left">问卷配置</el-divider>
        <el-form-item label="启用客评">
          <el-switch
            v-model="settingsForm.enabled"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="问卷ID">
          <el-input
            v-model.trim="settingsForm.formId"
            maxlength="64"
            placeholder="SCRM 问卷 formId"
          ></el-input>
        </el-form-item>
        <el-form-item label="算分题">
          <el-input
            v-model.trim="settingsForm.scoreCodes"
            maxlength="500"
            placeholder="如 Q1,Q2,Q3；留空表示全部 1-5 分评分题"
          ></el-input>
        </el-form-item>
        <el-form-item label="不算分题">
          <el-input
            v-model.trim="settingsForm.npsCodes"
            maxlength="500"
            placeholder="如 Q11（推荐题）"
          ></el-input>
        </el-form-item>

        <el-divider content-position="left">评价送积分</el-divider>
        <el-form-item label="开启送积分">
          <el-switch v-model="pointForm.enabled"></el-switch>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="首次送">
              <el-input-number
                v-model="pointForm.firstPoints"
                :min="0"
                :precision="0"
                :step="1"
                :controls="false"
                style="width:150px"
              ></el-input-number>
              <span class="unit">积分</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="后续送">
              <el-input-number
                v-model="pointForm.freqPoints"
                :min="0"
                :precision="0"
                :step="1"
                :controls="false"
                style="width:150px"
              ></el-input-number>
              <span class="unit">积分</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="统计天数">
              <el-input-number
                v-model="pointForm.windowDays"
                :min="1"
                :controls="false"
                style="width:150px"
              ></el-input-number>
              <span class="unit">天</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="前几次不送">
              <el-input-number
                v-model="pointForm.thresholdTimes"
                :min="1"
                :controls="false"
                style="width:150px"
              ></el-input-number>
              <span class="unit">次</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最多送">
              <el-input-number
                v-model="pointForm.maxRewardTimes"
                :min="1"
                :controls="false"
                style="width:150px"
              ></el-input-number>
              <span class="unit">次</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最低分">
              <el-input
                v-model="pointForm.minScore"
                class="min-score-input"
                type="number"
                min="0"
                max="5"
                step="0.1"
                placeholder="不限"
              ></el-input>
              <span class="unit">分</span>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="point-rule-tip">
          <div>
            首次赠送
            <span class="point-rule-num">{{ pointRuleValues.first }}</span>
            积分；
          </div>
          <div>
            <span class="point-rule-num">{{ pointRuleValues.days }}</span>
            天内，评价超过
            <span class="point-rule-num">{{ pointRuleValues.threshold }}</span>
            次，从第
            <span class="point-rule-num">{{ pointRuleValues.start }}</span>
            次开始，赠送积分
            <span class="point-rule-num">{{ pointRuleValues.freq }}</span>
            分，
            <span class="point-rule-num">{{ pointRuleValues.days }}</span>
            天内最多赠送
            <span class="point-rule-num">{{ pointRuleValues.max }}</span>
            次。
          </div>
        </div>

        <div class="config-note">
          <div>算分题：只填题号，如 Q1,Q2,Q3；留空表示所有 1-5 分评分题都算总分。</div>
          <div>不算分题：推荐题通常是 0-10 分，例如 Q11 填这里，不参与总分。</div>
          <div>送积分只能填整数；最低分留空表示不限。</div>
          <div>问卷ID变更后，新评价使用新问卷；历史评价按原记录展示。</div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="settingsVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="settingsSaving" @click="saveSettings">
          保存
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="订单评价引导配置"
      :visible.sync="guideVisible"
      :close-on-click-modal="false"
      width="860px"
    >
      <div class="guide-tip">
        配置各评价维度在不同星级下展示的快捷提示词；多个提示词用逗号分隔。小程序读取不到配置时使用系统默认提示词。
      </div>
      <el-table
        class="guide-config-table"
        :data="guideRows"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column prop="label" label="评价维度" width="120"></el-table-column>
        <el-table-column label="五星">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.high"
              maxlength="80"
              size="small"
              placeholder="如：热情主动，耐心有礼"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="四星">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.medium"
              maxlength="80"
              size="small"
              placeholder="如：礼貌接待，不强行推销"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="三星及以下">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.low"
              maxlength="80"
              size="small"
              placeholder="如：态度差，强推夸大"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="guide-tip guide-tip-sub">
        配置保存后立即生效；未配置时使用系统默认提示词。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="guideVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="guideSaving" @click="saveGuideSettings">
          保存
        </el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
const GUIDE_DIMENSIONS = [
  { key: "serviceScore", label: "服务态度" },
  { key: "guiderScore", label: "导购专业度" },
  { key: "envScore", label: "门店环境卫生" }
];

const DEFAULT_GUIDE_ROWS = {
  serviceScore: {
    high: "热情主动，耐心有礼，尊重顾客，不强推",
    medium: "礼貌接待，无争执，不强行推销",
    low: "冷落顾客，态度差，敷衍争辩，强推夸大"
  },
  guiderScore: {
    high: "知识扎实，按需推荐，讲解易懂，可信",
    medium: "熟悉产品，可简单解答，按需推荐",
    low: "产品不熟，盲目推荐，夸大功效，讲解难懂"
  },
  envScore: {
    high: "干净无异味，陈列规范，防护到位，配套齐全",
    medium: "整体整洁，标签齐全，基础安全，配套具备",
    low: "脏乱有异味，陈列混乱，安全隐患，配套缺失"
  }
};

function createGuideRows() {
  return GUIDE_DIMENSIONS.map(item => ({
    key: item.key,
    label: item.label,
    high: DEFAULT_GUIDE_ROWS[item.key].high,
    medium: DEFAULT_GUIDE_ROWS[item.key].medium,
    low: DEFAULT_GUIDE_ROWS[item.key].low
  }));
}

export default {
  components: {},
  data() {
    return {
      typeVal: "serve",
      listServe:[],
      listCommodity:[],
      listPos:[],
      listServiceItem:[],
      ruleForm: {
        name: "",
        helpText: "",
        value: "",
        code: "",
        configId: ""
      },
      rules: {
        name: {
          required: true,
          message: "请输入评价项目",
          trigger: "change"
        },
        helpText: {
          required: true,
          message: "请输入项目别称",
          trigger: "change"
        },
        value: {
          required: true,
          message: "请选择是否开启",
          trigger: "change"
        }
      },
      title: "",
      searchCondition: {},
      dialogVisible: false,
      list: [],
      row: {},
      settingsVisible: false,
      settingsSaving: false,
      settingsForm: {
        enabled: "1",
        formId: "",
        scoreCodes: "",
        npsCodes: ""
      },
      pointForm: {
        enabled: true,
        firstPoints: 20,
        freqPoints: 5,
        windowDays: 30,
        thresholdTimes: 3,
        maxRewardTimes: 5,
        minScore: null
      },
      guideVisible: false,
      guideSaving: false,
      guideTextId: "",
      guideRows: createGuideRows()
    };
  },
  computed: {
    pointRuleValues() {
      const threshold = Number(this.pointForm.thresholdTimes || 0);
      return {
        first: Number(this.pointForm.firstPoints || 0),
        freq: Number(this.pointForm.freqPoints || 0),
        days: Number(this.pointForm.windowDays || 0),
        threshold,
        start: threshold + 1,
        max: Number(this.pointForm.maxRewardTimes || 0)
      };
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    handoff(val){
      this.typeVal = val;
      if(val === "serve"){
        this.list = this.listServe;
      }
      if(val === "commodity"){
        this.list = this.listCommodity;
      }
      if(val === "pos"){
        this.list = this.listPos;
      }
      if(val === "serviceItem"){
        this.list = this.listServiceItem;
      }
    },
    async openSettings() {
      const { code, result, errMsg } = await this.$store.dispatch(
        "queryEvaluationSettings",
        {}
      );
      if (code !== "0") {
        this.$message.error(errMsg || "查询客评配置失败");
        return;
      }
      const form = (result && result.formConfig) || {};
      const point = (result && result.pointConfig) || {};
      this.settingsForm = {
        enabled: form.enabled || "1",
        formId: form.formId || "",
        scoreCodes: form.scoreCodes || "",
        npsCodes: form.npsCodes || ""
      };
      this.pointForm = {
        enabled: !(point.enabled === false || point.enabled === "false" || point.enabled === 0),
        firstPoints: point.firstPoints != null ? point.firstPoints : 20,
        freqPoints: point.freqPoints != null ? point.freqPoints : 5,
        windowDays: point.windowDays != null ? point.windowDays : 30,
        thresholdTimes: point.thresholdTimes != null ? point.thresholdTimes : 3,
        maxRewardTimes: point.maxRewardTimes != null ? point.maxRewardTimes : 5,
        minScore: point.minScore != null ? point.minScore : null
      };
      this.settingsVisible = true;
    },
    async saveSettings() {
      if (this.settingsForm.enabled === "1" && !this.settingsForm.formId) {
        this.$message.error("启用客评时必须配置问卷ID");
        return;
      }
      const pointConfig = {
        enabled: this.pointForm.enabled,
        firstPoints: Number(this.pointForm.firstPoints || 0),
        freqPoints: Number(this.pointForm.freqPoints || 0),
        windowDays: Number(this.pointForm.windowDays || 30),
        thresholdTimes: Number(this.pointForm.thresholdTimes || 3),
        maxRewardTimes: Number(this.pointForm.maxRewardTimes || 5),
        minScore:
          this.pointForm.minScore === null || this.pointForm.minScore === ""
            ? null
            : Number(this.pointForm.minScore)
      };
      this.settingsSaving = true;
      try {
        const { code, errMsg } = await this.$store.dispatch(
          "saveEvaluationSettings",
          Object.assign({}, this.settingsForm, {
            pointConfigJson: JSON.stringify(pointConfig)
          })
        );
        if (code === "0") {
          this.$message.success("保存成功");
          this.settingsVisible = false;
        } else {
          this.$message.error(errMsg || "保存失败");
        }
      } finally {
        this.settingsSaving = false;
      }
    },
    async openGuideSettings() {
      try {
        const { code, result, errMsg } = await this.$store.dispatch(
          "queryOrderGuideText",
          { textCode: "orderEvaluationGuideConfig" }
        );
        if (code !== "0") {
          this.$message.error(errMsg || "查询订单评价引导配置失败");
          return;
        }
        this.guideTextId = (result && result.textId) || "";
        this.guideRows = this.parseGuideRows(result && result.textContentZhCn);
        this.guideVisible = true;
      } catch (e) {
        this.$message.error("查询订单评价引导配置失败");
      }
    },
    guideTagsToString(value) {
      if (Array.isArray(value)) {
        return value.filter(Boolean).join("，");
      }
      if (value && Array.isArray(value.tags)) {
        return value.tags.filter(Boolean).join("，");
      }
      return typeof value === "string" ? value : "";
    },
    guideStringToTags(value) {
      return String(value || "")
        .split(/[,，、;；\s]+/)
        .map(item => item.trim())
        .filter(Boolean);
    },
    parseGuideRows(value) {
      let parsed = {};
      if (value) {
        try {
          parsed = typeof value === "string" ? JSON.parse(value) : value;
        } catch (e) {
          parsed = {};
        }
      }
      return GUIDE_DIMENSIONS.map(item => {
        const config = parsed[item.key] || {};
        const fallback = DEFAULT_GUIDE_ROWS[item.key];
        return {
          key: item.key,
          label: item.label,
          high: this.guideTagsToString(config.high || config["5"] || fallback.high),
          medium: this.guideTagsToString(config.medium || config["4"] || fallback.medium),
          low: this.guideTagsToString(config.low || config["3"] || fallback.low)
        };
      });
    },
    async saveGuideSettings() {
      const config = {};
      this.guideRows.forEach(row => {
        config[row.key] = {
          high: this.guideStringToTags(row.high),
          medium: this.guideStringToTags(row.medium),
          low: this.guideStringToTags(row.low)
        };
      });
      const value = JSON.stringify(config);
      const params = {
        textId: this.guideTextId || undefined,
        textCode: "orderEvaluationGuideConfig",
        textName: "订单评价引导配置",
        textType: "json",
        textContentZhCn: value
      };
      this.guideSaving = true;
      try {
        const { code, errMsg } = await this.$store.dispatch(
          "saveOrderGuideText",
          params
        );
        if (code === "0") {
          this.$message.success("保存成功");
          this.guideVisible = false;
        } else {
          this.$message.error(errMsg || "保存失败");
        }
      } catch (e) {
        this.$message.error("保存失败");
      } finally {
        this.guideSaving = false;
      }
    },
    async submit() {
      const valid = this.$refs.ruleForm.validate();
      if (valid) {
        this.operation(this.ruleForm);
      }
    },
    edit(row) {
      this.row = row;
      this.title = "编辑";
      for (let key in this.ruleForm) {
        this.ruleForm[key] = row[key];
      }
      this.dialogVisible = true;
    },
    up(row) {
      let newRow = JSON.parse(JSON.stringify(row));
      newRow.value = newRow.value === "yes" ? "no" : "yes";
      this.operation(newRow);
    },
    async operation(row) {
      let params = {
        configId: row.configId,
        value: row.value,
        helpText: row.helpText,
        code: row.code
      };
      const { code } = await this.$store.dispatch(
        "editMemberShowConfig",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.dialogVisible = false;
        this.queryList();
      }
    },
    async queryList() {
      let params = {
        codeType:"all",
        codeList:["orderScoreConfig","serviceReservationScoreConfig","posOrderScoreConfig","serviceItemScoreConfig"]
      };
      const { result } = await this.$store.dispatch(
        "queryMemberShowScoreConfigList",
        params
      );

      let listServe = [];
      let listCommodity = [];
      let listPos = [];
      let listServiceItem = [];
      result.forEach(item => {
        if (item.code === "serviceReservationScoreConfig") {
          listServe.push(item);
        }
        if(item.code === "orderScoreConfig"){
            listCommodity.push(item);
        }
        if(item.code === "posOrderScoreConfig"){
            listPos.push(item);
        }
        if(item.code === "serviceItemScoreConfig"){
            listServiceItem.push(item);
        }
      });
      this.listServe = listServe;
      this.listCommodity = listCommodity;
      this.listPos = listPos;
      this.listServiceItem = listServiceItem;
      // 刷新后保持当前 tab，避免编辑服务项目后跳回服务预约
      this.handoff(this.typeVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.evaluation-config-form /deep/ .el-input,
.evaluation-config-form /deep/ .el-select,
.evaluation-config-form /deep/ .el-textarea {
  width: 100% !important;
}
.evaluation-config-form /deep/ .el-input-number {
  width: 150px !important;
}
.evaluation-config-form /deep/ .el-input-number .el-input {
  width: 100% !important;
}
.evaluation-config-form /deep/ .el-input.min-score-input {
  width: 150px !important;
}
.evaluation-config-form /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}
.unit {
  margin-left: 8px;
  color: #606266;
  font-size: 13px;
}
.point-rule-tip {
  margin: 0 0 16px 100px;
  padding: 12px 14px;
  background: #fff7fa;
  border: 1px solid #fde2eb;
  border-radius: 6px;
  color: #606266;
  font-size: 13px;
  line-height: 1.8;
}
.point-rule-num {
  color: #e50065;
  font-weight: 600;
}
.config-note {
  margin-left: 100px;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.8;
}
.guide-tip {
  margin-bottom: 12px;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
.guide-tip-sub {
  margin-top: 10px;
  margin-bottom: 0;
}
.guide-config-table /deep/ .el-input__inner {
  font-size: 12px;
}
</style>
